export { TENANT_COLORS as UserTheme } from '../../tenant/types';
